import HelpCenterHits from "./search-content/help-center-hits/help-center-hits";
import algoliasearch from "algoliasearch/lite";
import {
  algoliaAPPID,
  algoliaSearchAPIKey,
  prismicAlgoliaIndexName,
  helpCenterAlgoliaIndexName,
} from "../../utils/constants";
import { SearchResults } from "react-instantsearch-core";
import { QueryStringObjectType } from "./query-string";

export const algoliaClient = algoliasearch(algoliaAPPID, algoliaSearchAPIKey);

export type SiteSearchResults = {
  queryID?: string; // populated by Algolia Instant Search, missing from Algolia types
} & SearchResults<any>;

type IndexConfig = {
  indexName: string;
  tabName: string;
  HitsComponent?: (props: SiteSearchResults) => JSX.Element;
  distinct: boolean;
}[];

export const prismicTabName = "All";
export const helpCenterTabName = "Help Center";

// Holds the config for just the ordered indices. Excludes the "All" tab.
export const tabIndexOrder: IndexConfig = [
  {
    indexName: prismicAlgoliaIndexName,
    tabName: prismicTabName,
    distinct: true,
    // HitsComponent: not included for first "All" tab since it requires all index results as props
    // this special case is handled with code in search-content.tsx
  },
  {
    indexName: helpCenterAlgoliaIndexName,
    tabName: helpCenterTabName,
    HitsComponent: HelpCenterHits,
    distinct: false,
  },
];

export const noSearchState: { metaText: string } = {
  metaText: "Most Viewed",
};

export const noResultsLinks: QueryStringObjectType[] = [
  {
    query: "3D Printing Service",
    index: prismicTabName,
  },
  {
    query: "CNC Machining Service",
    index: prismicTabName,
  },
  {
    query: "Sheet Metal Fabrication Services",
    index: prismicTabName,
  },
  {
    query: "Grow Your Business",
    index: prismicTabName,
  },
  {
    query: "Laser Cutting Service",
    index: prismicTabName,
  },
  {
    query: "Materials",
    index: prismicTabName,
  },
  {
    query: "Become a Supplier",
    index: helpCenterTabName,
  },
  {
    query: "Injection Molding Service",
    index: prismicTabName,
  },
  {
    query: "Waterjet Cutting Service",
    index: prismicTabName,
  },
  {
    query: "Terms and Conditions",
    index: prismicTabName,
  },
  {
    query: "Legal",
    index: prismicTabName,
  },
  {
    query: "Standards",
    index: prismicTabName,
  },
  {
    query: "Reset Password",
    index: helpCenterTabName,
  },
  {
    query: "Add-Ins",
    index: prismicTabName,
  },
  {
    query: "Blog",
    index: prismicTabName,
  },
  {
    query: "Contact Us",
    index: prismicTabName,
  },
  {
    query: "CNC Milling",
    index: prismicTabName,
  },
  {
    query: "Urethane Casting",
    index: prismicTabName,
  },
  {
    query: "ITAR Registration",
    index: helpCenterTabName,
  },
  {
    query: "Security",
    index: helpCenterTabName,
  },
];
